"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author tatevik.marikyan
 * @since 29/07/2018
 */
var HierarchicalSearchItem = /** @class */ (function () {
    /**
     * Model for each searched result item in Hierarchical Search component
     * @param {string} displayName
     * @param {Map<string, number>} fieldValueMapping - Hierarchical items Meta Filed Name / value (ClassifierId) mapping
     * @param {HierarchicalEntityItem} entityItem
     */
    function HierarchicalSearchItem(displayName, fieldValueMapping, entityItem) {
        this.displayName = displayName;
        this.fieldValueMapping = fieldValueMapping;
        this.entityItem = entityItem;
    }
    return HierarchicalSearchItem;
}());
exports.HierarchicalSearchItem = HierarchicalSearchItem;
//# sourceMappingURL=hierarchical-search-item.model.js.map